import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { COLOR_GREY_10 } from "shared/theme/colors";

type AutocompleteHintProps = {
  mainText: string;
  mainColor: string;
  selectedValue?: string;
  fontWeight?: number;
};

const AutocompleteHint: FC<AutocompleteHintProps> = ({
  mainText,
  mainColor,
  selectedValue,
  fontWeight = 400,
}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="end">
      <Typography color={mainColor} variant="caption" fontWeight={fontWeight}>
        {mainText}
      </Typography>
      {selectedValue && (
        <Typography
          fontSize={10}
          fontWeight={400}
          color={COLOR_GREY_10}
          variant="caption"
        >
          {selectedValue}
        </Typography>
      )}
    </Box>
  );
};

export default AutocompleteHint;
